// Sentry crash reporting — no-op without REACT_APP_SENTRY_DSN so local dev
// keeps running without errors. Must be imported BEFORE React renders.
import * as Sentry from "@sentry/react";

const DSN = (process.env.REACT_APP_SENTRY_DSN || "").trim();
const ENV = process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV || "production";
const RELEASE = process.env.REACT_APP_VERSION || "quattro@unknown";

let _initialized = false;

export function initSentry() {
  if (_initialized) return true;
  if (!DSN) {
    if (process.env.NODE_ENV !== "production") {
      console.info("[sentry] REACT_APP_SENTRY_DSN not set — crash reporting disabled.");
    }
    return false;
  }
  try {
    Sentry.init({
      dsn: DSN,
      environment: ENV,
      release: RELEASE,
      tracesSampleRate: ENV === "production" ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 0.5,
      sendDefaultPii: false,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true }),
      ],
    });
    _initialized = true;
    return true;
  } catch (e) {
    console.warn("[sentry] init failed:", e);
    return false;
  }
}

// Re-export for callers that want to capture explicit events.
export { Sentry };
